// import { CookieStorage } from "redux-persist-cookie-storage";
import storage from "redux-persist/lib/storage";

const persistConfig = () => ({
	key: "root",
	storage,
	// storage: new CookieStorage(clientServerCookie /*, options */),
	// stateReconciler(inboundState, originalState) {
	// 	// Ignore state from cookies, only use preloadedState from window object
	// 	return originalState;
	// },
	blacklist: [
		"pageLoading",
		"router",
		"Maintenance",
		// "deviceBookingList",
		// "testCounter6",
		// "testCounter5",
		// "testCounter4",
		// "Language",
		"DialogLogin",
	],
	// whitelist: ["personDetails"],
});

export default persistConfig;
